/**
 * @generated SignedSource<<66c15b9bd23abc1cbd891cd9de9a2143>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionMode = "FREE_CHAT" | "TOPIC" | "%future added value";
export type SessionStatus = "ACTIVE" | "DEBRIEFED" | "DEBRIEFING" | "ENDED" | "FAILED" | "%future added value";
export type StartSessionInput = {
  characterId?: string | null | undefined;
  learnerId: string;
  mode: SessionMode;
  practiceItemId?: string | null | undefined;
  storyBookId?: string | null | undefined;
  topic?: string | null | undefined;
  utcOffsetMinutes?: number | null | undefined;
  vocabularyItemId?: string | null | undefined;
};
export type SessionProviderStartSessionMutation$variables = {
  input: StartSessionInput;
};
export type SessionProviderStartSessionMutation$data = {
  readonly startSession: {
    readonly audioToken: string;
    readonly audioWsUrl: string;
    readonly session: {
      readonly character: {
        readonly accentHex: string;
        readonly artKey: string;
        readonly audience: string;
        readonly displayName: string;
        readonly intensity: number;
      } | null | undefined;
      readonly id: string;
      readonly status: SessionStatus;
      readonly storyTitle: string | null | undefined;
      readonly topic: string | null | undefined;
    };
  };
};
export type SessionProviderStartSessionMutation = {
  response: SessionProviderStartSessionMutation$data;
  variables: SessionProviderStartSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "topic",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "storyTitle",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "artKey",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accentHex",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "intensity",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audioWsUrl",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audioToken",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionProviderStartSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "StartSessionPayload",
        "kind": "LinkedField",
        "name": "startSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "character",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*:: as any*/),
          (v12/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SessionProviderStartSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "StartSessionPayload",
        "kind": "LinkedField",
        "name": "startSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "character",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*:: as any*/),
          (v12/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "556842dc101b29637f58a412b3ee869d",
    "id": null,
    "metadata": {},
    "name": "SessionProviderStartSessionMutation",
    "operationKind": "mutation",
    "text": "mutation SessionProviderStartSessionMutation(\n  $input: StartSessionInput!\n) {\n  startSession(input: $input) {\n    session {\n      id\n      status\n      topic\n      storyTitle\n      character {\n        artKey\n        audience\n        displayName\n        accentHex\n        intensity\n        id\n      }\n    }\n    audioWsUrl\n    audioToken\n  }\n}\n"
  }
};
})();

(node as any).hash = "e29233852e019c90e86ef822616ca554";

export default node;
